import MockupColorSwitcher from './MockupColorSwitcher'
export default MockupColorSwitcher
